/* @ngInject */
const saleResource = (
  $resource,
  paths
) => {
  const path = `${paths.handlers.sale}/:action`

  return $resource(
    path,
    { action: '@action' }, {
    'update': {
      method: 'PUT',
    },
    'query': {
      method: 'GET',
    },
    'get': {
      method: 'GET',
      isArray: false,
    },
    'post': {
      method: 'POST',
    },
  }
  )
}

export default saleResource



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/services/resource.service.js